import React, { useState, useEffect, useRef } from 'react';
import { Typography, Tooltip, Icon } from 'antd';
import moment from 'moment';
import styles from './Documents.module.scss';

const { Text } = Typography;

const formatDate = (date) => moment(date).format('DD.MM.YYYY');

const EllipsisText = ({ description }) => {
  const textRef = useRef();

  const [isTextOverflow, setIsTextOverflow] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const isOverflow =
        textRef.current.offsetWidth < textRef.current.scrollWidth;
      setIsTextOverflow(isOverflow);
    }
  }, [description, textRef.current]);

  return (
    <Tooltip title={isTextOverflow ? description : ''}>
      <span className={styles.description} ref={textRef}>
        {description}
      </span>
    </Tooltip>
  );
};

const AdditionalContent = ({ attachment }) => {
  const { fromDate, toDate, availableForClient, description } =
    attachment || {};

  if (!description && !availableForClient) {
    return null;
  }

  return (
    <div className={styles.additionalContentBlock}>
      {description && <EllipsisText description={description} />}
      {availableForClient && fromDate && (
        <div className={styles.periodBlock}>
          <Tooltip title="Показывается собственнику">
            <Icon type="eye" className={styles.eyeIcon} />
          </Tooltip>

          <Text>
            {toDate
              ? `${formatDate(fromDate)} - ${formatDate(toDate)}`
              : `с ${formatDate(fromDate)}`}
          </Text>
        </div>
      )}
    </div>
  );
};

export default AdditionalContent;
